import { render, staticRenderFns } from "./LaudoFilaProcedimento.vue?vue&type=template&id=04dbddc0&"
import script from "./LaudoFilaProcedimento.vue?vue&type=script&lang=js&"
export * from "./LaudoFilaProcedimento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports